/**
 * Health radar chart for pump summary — same dimensions as Data Analytics report.
 */
import {
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';

export default function AdminPumpHealthRadar({ radar = [], loading = false }) {
  if (loading) {
    return (
      <div className="admin-pump-hub__health-radar mt-3">
        <p className="small text-muted mb-0 text-center py-4">Loading health radar…</p>
      </div>
    );
  }

  if (!radar?.length) {
    return (
      <div className="admin-pump-hub__health-radar mt-3">
        <p className="small text-muted mb-0 text-center py-4">No radar data for this period.</p>
      </div>
    );
  }

  return (
    <div className="admin-pump-hub__health-radar mt-3">
      <h3 className="h6 mb-1">Health radar</h3>
      <p className="small text-muted mb-2">Five dimensions of pump performance (0–100)</p>
      <div className="admin-pump-hub__health-radar-chart">
        <ResponsiveContainer width="100%" height={220}>
          <RadarChart data={radar} cx="50%" cy="50%" outerRadius="68%" margin={{ top: 12, right: 20, bottom: 12, left: 20 }}>
            <PolarGrid stroke="#e8e4f8" />
            <PolarAngleAxis dataKey="axis" tick={{ fontSize: 10, fill: '#64748B' }} />
            <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{ fontSize: 9 }} axisLine={false} />
            <Radar
              name="Score"
              dataKey="score"
              stroke="#5D38DB"
              fill="#5D38DB"
              fillOpacity={0.3}
              strokeWidth={2}
            />
            <Tooltip formatter={(value) => [`${value}/100`, 'Score']} />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
